export default __webpack_public_path__ + "static/media/check.19648102.svg";